import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from '@zg-rentals/zdash';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import { DEBOUNCE_WAIT_TIME } from '@common/constants';

interface IDebouncedButtonProps {
  children: React.ReactNode;
  type?: string;
  full?: boolean;
  disabled?: boolean;
  icon?: any;
  dataTest?: string;
  size?: string;
  onClick: (...args: any[]) => any;
}

class DebouncedButton extends React.Component<IDebouncedButtonProps> {
  static defaultProps = {
    onClick: () => {},
  };

  static propTypes = {
    onClick: PropTypes.func,
  };
  debouncedOnClick: any;
  constructor(props) {
    super(props);
    this.debouncedOnClick = debounce(props.onClick, DEBOUNCE_WAIT_TIME, true);
  }

  render() {
    const { ...rest } = this.props;
    return <Button {...rest} onClick={this.debouncedOnClick} />;
  }
}

export default DebouncedButton;
